import {ValueObject} from '@s-ui/domain'

import {NumberSharedValueObject} from '../../shared/ValueObjects/NumberSharedValueObject.js'

export class FilterNumberSearchValueObject extends ValueObject {
  #number

  constructor({number}) {
    super()
    this.#number = number
  }

  static create({number}) {
    return new FilterNumberSearchValueObject({
      number: NumberSharedValueObject.create({value: number})
    })
  }

  get isEmpty() {
    return this.#number.value === null || this.#number.value === undefined
  }

  get value() {
    return this.#number.value
  }

  toJSON() {
    return {number: this.#number.toJSON()}
  }
}
